<ion-header class="background-lightmimbo">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/donate"></ion-back-button>
    </ion-buttons>
    <ion-title>Authorities</ion-title>
  </ion-toolbar>
  <ion-searchbar class="searchbar" #searchBar (ionInput)="onFilterChanged(searchBar)"
    *ngIf="!isLoading"></ion-searchbar>
</ion-header>

<ion-content color="lightmimbo">
  <div class="ion-text-center ion-padding" *ngIf="isLoading">
    <ion-spinner color="primary"></ion-spinner>
  </div>
  <ion-grid *ngIf="!isLoading" class="munList">
    <ion-row *ngFor="let authority of filteredAuthoritiesList">
      <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
        <ion-card class="post">
          <ion-card-header>
            <ion-card-title class="title" color="darkmimbo">{{formatName(authority)}}</ion-card-title>
            <ion-card-subtitle class="district" color="darkmimbo">{{authority.District + ' - ' +
              authority.District_Ar}}</ion-card-subtitle>
          </ion-card-header>
          <ion-card-content class="numbers">
            <ion-button fill="outline" shape="round" class="call-btn" color="primary"
              *ngFor="let p of phones(authority)" (click)="call(p)">
              <ion-icon slot="start" name="call-outline" class="call-icon"></ion-icon>
              <span class="call-text">{{formatNumber(p)}}</span>
            </ion-button>
          </ion-card-content>
        </ion-card>
      </ion-col></ion-row></ion-grid>
</ion-content>